export const HttpResCode = {
	// #region info (1xx)
	SWITCHING_PROTOCOLS: 101,
	// #endregion

	// #region success (2xx)
	OK: 200,
	CREATED: 201,
	NO_CONTENT: 204,
	// #endregion

	// #region redirection (3xx)
	NOT_MODIFIED: 304,
	// #endregion

	// #region client error (4xx)
	BAD_REQUEST: 400,
	UNAUTHORIZED: 401,
	PAYMENT_REQUIRED: 402,
	FORBIDDEN: 403,
	NOT_FOUND: 404,
	CONFLICT: 409,
	GONE: 410,
	PAYLOAD_TOO_LARGE: 413,
	UNSUPPORTED_MEDIA_TYPE: 415,
	UNPROCESSABLE_CONTENT: 422,
	UPGRADE_REQUIRED: 426,
	// #endregion

	// #region server error (5xx)
	INTERNAL_SERVER_ERROR: 500,
	BAD_GATEWAY: 502,
	SERVICE_UNAVAILABLE: 503,
	// #endregion
} as const;
